import { Box } from "@chakra-ui/react"
import { Outlet } from "react-router-dom";
import {NavBar, SideBar} from './';
import { useEffect } from "react";
import { useAtom } from "jotai";
import { notificationAtom, openNAtom } from "../../context";
import apiCall from "../../utils/apiCall";
import { useQuery } from "react-query";
import appStore,{activePeriod,userAtom} from '../../store';

const ContainerStyle = {
  margin:'0',
  p:'0',
  width:"100vw",
  height:'100dvh',
  display:'flex',
  position:"fixed",
  top:"0",
  left:"0"
}
const contentStyle = {
  overflowY:'auto',
  overflowX:'hidden'
}
export const Dashboard = () => {
  const [,set_notification] = useAtom(notificationAtom);
  const [,open_notification] = useAtom(openNAtom);
  // const { data: aPeriod } = useQuery(
  //   ['active-period'],
  //   {
  //     queryFn: async () => {
  //       let tempUserData = localStorage.getItem('user-data');
  //       let token = tempUserData ? JSON.parse(tempUserData)?.Token : null;
  
  //       return await apiCall().get(`exam/setup/examPeriod/active`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //     },
  //     select(data) {
  //       return data?.data?.Data;
  //     },
  //   }
  // );
  
  // if (aPeriod && aPeriod?.Id)
  //   appStore.set(activePeriod, {
  //     Id: aPeriod.Id,
  //     Name: aPeriod.ExamName,
  //   });
  
//     useEffect(() => {
//       let tempUserData = localStorage.getItem('user-data');
//       if (tempUserData) {
//         let uData = JSON.parse(tempUserData);
//         if (uData?.justLogged) {
//           uData.justLogged = false;
//           localStorage.setItem('user-data', JSON.stringify(uData));
//           set_notification({
//             type: 'success',
//             message: 'Login successful',
//           });
    
//           setTimeout(() => {
//             open_notification(true);
//           }, 0); // Ensures it happens after the state update
//         }
//       }
//     }, [set_notification, open_notification]);
    
  
//   return (
//     <Box sx={ContainerStyle}>
//       <SideBar />
//       <Box
//         sx={contentStyle}
//         position="relative"
//         flexGrow="1"
//         height="100%"
//         p="0 30px 30px"
//         bg="var(--content-background)"
//       >
//         <NavBar />
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }
  
  const {data:aPeriod} = useQuery(['active-period'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
    select(data){
      return data?.data?.Data;
    },
  });
  if(aPeriod && aPeriod?.Id)
  appStore.set(activePeriod,{
    Id:aPeriod.Id,
    Name:aPeriod.ExamName
  })
  let tempUserData = localStorage.getItem('user-data');
  let uData = JSON.parse(tempUserData || '{}');

  useEffect(()=>{
    
    if(tempUserData){

        appStore.set(userAtom, uData);
      if(uData?.justLogged){
        uData.justLogged = false;
        //console.log(JSON.stringify(uData.Token),'api token');
        localStorage.setItem('user-data',JSON.stringify(uData));
        set_notification({
          type:'success',
          message:'Login successful'
        })
        open_notification(true);
        
      }
    }

  },[])
  return (
    <Box sx={ContainerStyle} >
      <SideBar/>
      <Box sx={contentStyle} position="relative" flexGrow="1" height="100%" p="0 30px 30px" bg="var(--content-background)">
        <NavBar />
        <Outlet />
      </Box>
    </Box>
  )
}
